import React, { useState } from "react";
import useProfileData from "../../../hooks/userProfileData";
import './MeusDados.css';

const EditProfile = ({ onSuccess }) => {
    const { profileData, loading, error } = useProfileData();
    const [editedData, setEditedData] = useState({});
    const API_URL = process.env.REACT_APP_API;
    const prefix = 'api/usuario-editora';
    const posfix = '-usuario-editora';

    const handleChange = (e) => {
        const { name, value } = e.target;

        // Normaliza o CPF removendo "." e "-"
        const normalizedValue =
            name === "cpf" ? value.replace(/[.-]/g, "") : value;

        setEditedData({ ...editedData, [name]: normalizedValue });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem('token');
        if (token) {
        try {
            const response = await fetch(API_URL + prefix + '/dados' + posfix, {
                method: "PUT",
                body: JSON.stringify(editedData),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: 'Bearer ' + token,
                },
            });
            if (!response.ok) {
                throw new Error("Erro ao atualizar os dados do perfil.");
            }
            alert("Dados do perfil atualizados com sucesso!");
            onSuccess(editedData);

        } catch (error) {
            alert("Erro ao atualizar os dados do perfil: " + error.message);
        }
    }
    };


    return (
        <div className="login-container editar-dados-container">
            <h2>Editar Perfil</h2>
            <form onSubmit={handleSubmit}>
                <div>
                    <label>Email:</label>
                    <input
                        type="email"
                        name="email"
                        defaultValue={profileData?.email}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div>
                    <label>Password:</label>
                    <input
                        type="password"
                        name="password"
                        defaultValue={profileData?.password}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div>
                    <label>CPF:</label>
                    <input
                        type="text"
                        name="cpf"
                        defaultValue={profileData?.cpf}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div>
                    <label>Telefone:</label>
                    <input
                        type="text"
                        name="telefone"
                        defaultValue={profileData?.telefone}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div>
                    <label>Nome:</label>
                    <input
                        type="text"
                        name="nome"
                        defaultValue={profileData?.nome}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div>
                    <label>Profissão:</label>
                    <input
                        type="text"
                        name="profissao"
                        defaultValue={profileData?.profissao}
                        onChange={handleChange}
                    />
                </div>
                
                {profileData?.permissao === 'autor' && (
                    <>
                    <div>
                        <label>Biografia:</label>
                        <textarea
                                className="form-control"
                            name="biografia"
                            defaultValue={profileData?.biografia}
                            onChange={handleChange}
                        />
                    </div>
                    <div>
                        <label>Facebook:</label>
                        <input
                            type="text"
                            name="facebook"
                            defaultValue={profileData?.facebook}
                            onChange={handleChange}
                        />
                    </div>
                    <div>
                        <label>Instagram:</label>
                        <input
                            type="text"
                            name="instagram"
                            defaultValue={profileData?.instagram}
                            onChange={handleChange}
                        />
                    </div>
                    <div>
                        <label>Linkedin:</label>
                        <input
                            type="text"
                            name="linkedin"
                            defaultValue={profileData?.linkedin}
                            onChange={handleChange}
                        />
                    </div>
                    <div>

                        <label>Twitter:</label>
                        <input
                            type="text"
                            name="twitter"
                            defaultValue={profileData?.twitter}
                            onChange={handleChange}
                        />
                    </div>
                    <div>

                        <label>Youtube:</label>
                        <input
                            type="text"
                            name="youtube"
                            defaultValue={profileData?.youtube}
                            onChange={handleChange}
                        />
                    </div>  
                    </>

                )}

                <div>
                    <label>Endereço:</label>
                    <input
                        type="text"
                        name="endereco"
                        defaultValue={profileData?.endereco}
                        onChange={handleChange}
                    />
                </div>
                <div>
                    <label>Número:</label>
                    <input
                        type="text" 
                        name="numero"
                        defaultValue={profileData?.numero}
                        onChange={handleChange}
                    />
                </div>
                <div>
                    <label>Complemento:</label>
                    <input
                        type="text"
                        name="complemento"
                        defaultValue={profileData?.complemento} 
                        onChange={handleChange}
                    />
                </div>
                <div>
                    <label>Bairro:</label>
                    <input
                        type="text"
                        name="bairro"
                        defaultValue={profileData?.bairro}
                        onChange={handleChange}
                    />
                </div>
                <div>
                    <label>Cidade:</label>
                    <input
                        type="text"
                        name="cidade"
                        defaultValue={profileData?.cidade}
                        onChange={handleChange}
                    />
                </div>
                <div>
                    <label>Estado:</label>
                    <input
                        type="text"
                        name="estado"   
                        defaultValue={profileData?.estado}
                        onChange={handleChange}
                    />
                </div>
                <div>
                    <label>CEP:</label>
                    <input
                        type="text"
                        name="cep"
                        defaultValue={profileData?.cep}
                        onChange={handleChange}
                    />
                </div>
                
            


                <button type="submit">Salvar Alterações</button>
            </form>

        </div>
    );
};

export default EditProfile;
